import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { deepmerge } from "../util/object.js";
import { openingTimeTypes, openingTimeWeekdays, bookingRuleTypes } from "../stations/constants.js";
import { rentContractStates } from "../rent_contracts/constants.js";
import { addressTypes, accountTypes } from "../user/constants.js";
var factory = function factory(defaults) {
  return function () {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return deepmerge(defaults(overrides), overrides);
  };
};
var nextStationId = 1000000;
export var newStation = factory(function () {
  return {
    id: nextStationId++,
    shortdescr: "Station shortdescr",
    address: {
      street: "Station-Straße 123",
      zipCode: "12345",
      city: "Station-City"
    },
    openingInfos: []
  };
});
var nextStationOpeningInfoId = 1000000;
export var newStationOpeningInfo = factory(function () {
  return {
    id: "openingInfo-".concat(nextStationOpeningInfoId++),
    lang: "DE-DE",
    text: "Mo-Fr: 8:00 bis 18:30 Uhr"
  };
});
var nextStationOpeningTimeId = 1000000;
export var newStationOpeningTime = factory(function () {
  return {
    id: nextStationOpeningTimeId++,
    state: "02",
    weekdayFrom: openingTimeWeekdays.SUNDAY,
    weekdayTill: openingTimeWeekdays.SATURDAY,
    // "OP" (geöffnet) | "CL" (geschlossen)
    type: openingTimeTypes.OPEN,
    // Defines date range for which the opening time is effective. Contrary to the
    // property names this range applies to open slots as well as closed slots
    // based on `type`.
    // These properties are used for actual dates only, the time is irrelevant.
    openDate: "2019-06-01T00:00:00+01:00",
    openDateTill: "2019-06-02T00:00:00+01:00",
    // Defines time range for which the opening time is effective. Contrary to the
    // property names this range applies to open slots as well as closed slots
    // based on `type`.
    // These properties are used for their times only, the date is irrelevant.
    openfromTime: "1900-01-01T07:00:00+01:00",
    openTillTime: "1900-01-01T19:00:00+01:00"
  };
});
export var newStationBookingRule = factory(function () {
  return {
    // "AH" (min. Vorlaufzeit) | "MA" (max. Vorlaufzeit) | "MD" (min. Mietdauer) | "MM" (max. Mietdauer)
    type: bookingRuleTypes.MIN_LEAD_TIME,
    value: "0",
    shortDescr: "0 Minuten"
  };
});
var nextClassificationId = 1000000;
export var newClassification = factory(function () {
  return {
    id: nextClassificationId++,
    wwwDescr: "Some WWW description",
    shortDescr: "Some short description",
    minDriverAge: "17",
    code: "Some code"
  };
});
var nextRentObjectId = 1000000;
export var newRentObject = factory(function (overrides) {
  return {
    id: nextRentObjectId++,
    baseCost: "0",
    imageUrl1: "https://example.org/some.jpg",
    properties: overrides.properties ? [] : [newRentObjectProperty({
      extCode1: "AS",
      value: "1"
    })],
    rentObjTypeImageList: []
  };
});
export var newRentObjectProperty = factory(function () {
  return {
    extCode1: "some-ext-code",
    key: "Some property",
    propertyWWWVisible: true,
    sortNo: 0
  };
});
export var newRentObjectImage = factory(function () {
  return {
    rentObjImageId: 0,
    rentObjTypeId: 0,
    sortNo: 0,
    propertyExtCode1: "some-ext-code",
    propertyId: 0,
    propertyValueId: 0,
    propertyValueShortDescr: "Some color name",
    propertyValueExtCode1: "#000000"
  };
});
var nextRentObjectOptionId = 1000000;
export var newRentObjectOption = factory(function () {
  return {
    id: nextRentObjectOptionId++,
    wwwvisible: 1,
    state: "02",
    amount: 0.0,
    amountTotal: 0.0,
    calcBase: "1X",
    sortNo: 1,
    key: "Some option",
    extCode1: "some-extcode"
  };
});
var nextRentContractId = 1000000;
export var newRentContract = factory(function (overrides) {
  return {
    id: nextRentContractId++,
    state: rentContractStates.REQUEST,
    amountSumGross: 0.0,
    priceWithoutPromocode: 0.0,
    rentObjTransacts: overrides.rentObjTransacts ? [] : [newRentObjectTransaction()],
    invoiceItems: overrides.invoiceItems ? [] : [newRentContractInvoiceItem()],
    rentContractProperties: [],
    tarifOptionUpdated: false
  };
});
var nextRentContractInvoiceItemId = 1000000;
export var newRentContractInvoiceItem = factory(function (overrides) {
  return {
    id: nextRentContractInvoiceItemId++,
    wwwDescr: "Some WWW description",
    shortDescr: "Some short description",
    enabled: true,
    included: "NO",
    ruleBL: "00",
    grossPrice: 0.0,
    totalPrice: 0.0
  };
});
var nextRentContractTariffOptionId = 1000000;
export var newRentContractTariffOption = factory(function () {
  return {
    id: nextRentContractTariffOptionId++,
    shortDescr: "Some short description",
    price: 0.0,
    priceCalcBase: "1X"
  };
});
var nextDeliveryAddressId = 1000000;
export var newDeliveryAddress = factory(function () {
  return {
    id: nextDeliveryAddressId++,
    surname: "",
    street: "",
    zipCode: "",
    city: ""
  };
});
var nextDeliveryContactId = 1000000;
export var newDeliveryContact = factory(function () {
  return {
    id: nextDeliveryContactId++,
    prefixKey: "",
    name: "",
    surname: "",
    phone: ""
  };
});
var nextRentObjectTransactionId = 1000000;
export var newRentObjectTransaction = factory(function () {
  return {
    id: nextRentObjectTransactionId++,
    transactType: "RC",
    coDateTime: "1970-01-01T00:00:00.000Z",
    ciDateTime: "1970-01-01T00:00:00.000Z",
    coStationId: 0,
    planCiStationId: 0,
    classificationId: 0,
    inclusiveMileage: 0
  };
});
var nextDriverId = 1000000;
export var newDriver = factory(function () {
  return {
    id: nextDriverId++,
    customerId: 0,
    calcPrefixKey: "",
    calcPrefix: "",
    prename: "",
    lastname: "",
    eMail: "",
    phone: ""
  };
});
var nextReservationHistoryItemId = 1000000;
export var newReservationHistoryItem = factory(function () {
  return {
    id: nextReservationHistoryItemId++,
    reservationNo: 192628,
    state: rentContractStates.RESERVATION,
    classificationDescr: "BMW 2er Active Tourer",
    // old endpoint (v1.1/rentcontract/simpleHistory)
    imageUrl1: "https://example.org/some.jpg",
    checkOutTimestamp: "2019-04-20T12:00:00+02:00",
    checkInTimestamp: "2019-04-20T14:00:00+02:00",
    checkOutStationName: "Hamburg Offakamp",
    amountSumGross: 180.0,
    cancelable: true,
    // new endpoint (v1.2/rentcontract/bookinghistory)
    calcCheckOutTimestamp: "2020-05-06T10:18:00+02:00",
    calcCheckInTimestamp: "2020-05-08T16:50:00+02:00",
    firstDriverName: "Fred",
    registrationNumber: "A-BC 123",
    listPriceGross: 123.45,
    invoiceAmountNet: 123.45,
    invoiceAmountGross: 123.45
  };
});
var nextUserId = 1000000;
export var newUser = factory(function (overrides) {
  return {
    id: nextUserId++,
    addresses: overrides.addresses ? [] : [newUserMainAddress()],
    classification4: accountTypes.B2C,
    // sign up
    login: "user-".concat(nextUserId, "@example.com"),
    _password: "mys3cr37p4ssw0rd",
    prefixKey: "",
    name: "",
    surname: "",
    mobile: "",
    // consent checkboxes
    tosConfirmed: true,
    consentToReceiveSnailMail: false,
    consentToReceiveEMail: false,
    consentToReceiveSms: false,
    // extend sign up
    street: "",
    building: "",
    zipCode: "",
    city: "",
    countryCode: "",
    identCardType: "",
    identificationCardNo: "",
    identcardCtry: "",
    licenceAuthority: "",
    identCardIssued: "",
    identcardValidTill: "",
    driverLicenceNo: "",
    licenceCtry: "",
    licenceDateIssued: ""
  };
});
export var newB2bUser = function newB2bUser() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return newUser(_objectSpread(_objectSpread({}, overrides), {}, {
    classification4: accountTypes.B2B
  }));
};
export var newB2cUser = function newB2cUser() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return newUser(_objectSpread(_objectSpread({}, overrides), {}, {
    classification4: accountTypes.B2C
  }));
};
var nextUserAddressId = 1000000;
export var newUserAddress = factory(function () {
  return {
    id: nextUserAddressId++,
    typeId: "00"
  };
});
export var newUserMainAddress = function newUserMainAddress() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return newUserAddress(_objectSpread(_objectSpread({}, overrides), {}, {
    typeId: addressTypes.MAIN
  }));
};
export var newUserBillingAddress = function newUserBillingAddress() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return newUserAddress(_objectSpread(_objectSpread({}, overrides), {}, {
    typeId: addressTypes.BILLING
  }));
};
var nextContactPersonId = 1000000;
export var newContactPerson = factory(function () {
  return {
    id: nextContactPersonId++,
    prefixKey: "",
    prefix: "",
    name: "",
    surname: "",
    address: {
      street: "",
      zipCode: "",
      city: "",
      country: "Deutschland",
      countryCode: "D",
      email: "",
      phone: ""
    }
  };
});
var nextAuthorizedUserId = 1000000;
export var newAuthorizedUser = factory(function () {
  return {
    id: nextAuthorizedUserId++,
    prefix: "Firma",
    prefixKey: "01",
    name: "insertEFFECT LZM+RG",
    surname: "GmbH",
    login: "alphabet+lzm-rechnung@insfx.com",
    personAccRec: 630261,
    masterCustomerId: 0,
    masterMasterCustomerId: 0,
    sumAmountVoucherNotCharged: 0.0,
    lastLoginDate: "2021-05-18T00:00:00+02:00",
    classification4: "01",
    showPricesAndTaxes: true,
    showOnlyTaxes: false,
    billingType: "DR",
    salesTaxId: "DE123456789",
    loggedIn: false,
    employee: false
  };
});
export var newBankAccount = factory(function () {
  return {
    iban: "DE1234567890123",
    swift: "FOO123BAR",
    // BIC
    bankname: "Kreissparkasse Ravensburg",
    defaultAccount: true
  };
});
var nextCreditCardId = 1000000;
export var newCreditCard = factory(function () {
  return {
    id: nextCreditCardId++,
    creditcardbrand: "Visa Card",
    hostedDataId: "hosted-data-id",
    cardowner: "Jane Doe",
    validTill: "04 / 2022",
    cardnumber: "(VISA) ... 4242"
  };
});
var nextConfigurationFieldsetId = 1000000;
export var newConfigurationFieldset = factory(function () {
  return {
    fieldsetId: nextConfigurationFieldsetId++,
    title: "Some title",
    infoText: "Some descriptive text",
    name: "Some name",
    items: []
  };
});
var nextCmsPageId = 1000000;
export var newCmsPage = factory(function () {
  return {
    id: nextCmsPageId++,
    name: "somepage",
    cmsName: "somepage",
    title: "Some title",
    content: "<h1>Some CMS page content</h1>",
    contentMIMEType: "HT"
  };
});